import { AppPaths } from "@/shared/common/enums";
import type { TBreadcrumbFunction, TBreadcrumbHandle } from "@/shared/common/types";
import { BackButton } from "@/shared/components";
import { Breadcrumb } from "@ab.uitools/ui-library/components/Breadcrumb";
import { type ReactNode, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useMatches, useNavigate } from "react-router-dom";

interface Props {
  children?: ReactNode;
}

export const PageHeader = ({ children }: Props) => {
  const navigate = useNavigate();
  const matches = useMatches();
  const { t, ready } = useTranslation();

  const breadCrumbItems = useMemo(() => {
    const filteredMatches = matches.filter(
      (match) => (match?.handle as TBreadcrumbHandle)?.breadcrumb
    );
    return filteredMatches
      .map((match, index) => {
        const crumb = ((match?.handle as TBreadcrumbHandle)
          ?.breadcrumb as TBreadcrumbFunction)(match);

        const key = crumb?.key;
        const params = crumb?.params;
        const meta = crumb?.meta ?? "";
        const isLast = index === filteredMatches.length - 1;

        return {
          value: index,
          label: key ? t(key, params) : meta,
          onClick: isLast ? () => {} : () => {
            const pathname = match.pathname === "/" ? AppPaths.Dashboard : match.pathname;
            navigate(pathname);
          },
        };
      });
  }, [matches, ready]);

  const activeTab = useMemo(() => {
    const filteredMatches = matches.filter(
      (match) => (match?.handle as TBreadcrumbHandle)?.breadcrumb
    );
    return filteredMatches.length - 1;
  }, [matches]);

  return (
    <div className="page-header">
      <BackButton action={() => navigate(-1)}/>
      <Breadcrumb
        breadCrumbItems={breadCrumbItems}
        selectedValue={activeTab}
        onSelect={() => {}}
      />
      <div className="actions-container">
        {children}
      </div>
    </div>
  );
};
